/**
 * 脑筋急转弯问题数据库
 * 包含英文、中文、法文三语言版本
 */

export const riddleQuestions = [
  // 简单题 (1-15)
  {
    id: 'riddle_001',
    difficulty: 'easy',
    en: {
      question: 'What has hands but cannot clap?',
      options: ['Clock', 'Statue', 'Monkey', 'Doll'],
      correct: 0,
      explanation: 'A clock has hands (hour, minute, and second hands) but cannot clap.'
    },
    zh: {
      question: '什么东西有手，但不能拍掌？',
      options: ['钟表', '雕像', '猴子', '娃娃'],
      correct: 0,
      explanation: '钟表有指针（通常称为"手"），但它不能拍掌。'
    },
    fr: {
      question: 'Qu\'est-ce qui a des mains mais ne peut pas applaudir?',
      options: ['Horloge', 'Statue', 'Singe', 'Poupée'],
      correct: 0,
      explanation: 'Une horloge a des aiguilles (qu\'on appelle parfois les mains) mais ne peut pas applaudir.'
    }
  },
  {
    id: 'riddle_002',
    difficulty: 'easy',
    en: {
      question: 'What can run but never walks?',
      options: ['Water', 'Wind', 'Car', 'Person'],
      correct: 0,
      explanation: 'Water can run (flow) but has no legs to walk with.'
    },
    zh: {
      question: '什么东西会跑但不能走？',
      options: ['水', '风', '汽车', '人'],
      correct: 0,
      explanation: '水可以流动（跑），但没有腿来走路。'
    },
    fr: {
      question: 'Qu\'est-ce qui peut courir mais jamais marcher?',
      options: ['Eau', 'Vent', 'Voiture', 'Personne'],
      correct: 0,
      explanation: 'L\'eau peut couler (courir) mais n\'a pas de jambes pour marcher.'
    }
  },
  {
    id: 'riddle_003',
    difficulty: 'easy',
    en: {
      question: 'I speak without a mouth and hear without ears. I have no body, but I come alive with wind. What am I?',
      options: ['Echo', 'Wind', 'Bird', 'Ghost'],
      correct: 0,
      explanation: 'An echo speaks (repeats) without a mouth and is heard without ears.'
    },
    zh: {
      question: '我没有嘴但会说话，没有耳朵但会听。我没有身体，但在风中活过来。我是什么？',
      options: ['回声', '风', '鸟', '幽灵'],
      correct: 0,
      explanation: '回声没有嘴但会说话（重复），没有耳朵但会听到。'
    },
    fr: {
      question: 'Je parle sans bouche et j\'entends sans oreilles. Je n\'ai pas de corps, mais je prends vie avec le vent. Qu\'est-ce que je suis?',
      options: ['Écho', 'Vent', 'Oiseau', 'Fantôme'],
      correct: 0,
      explanation: 'Un écho parle (répète) sans bouche et s\'entend sans oreilles.'
    }
  },
  {
    id: 'riddle_004',
    difficulty: 'easy',
    en: {
      question: 'What has a face and two hands but no arms or legs?',
      options: ['Clock', 'Watch', 'Moon', 'Sun'],
      correct: 0,
      explanation: 'A clock has a face and hands (for telling time) but no arms or legs.'
    },
    zh: {
      question: '什么东西有脸和两只手，但没有胳膊和腿？',
      options: ['时钟', '手表', '月亮', '太阳'],
      correct: 0,
      explanation: '时钟有表盘（脸）和指针（手），但没有胳膊和腿。'
    },
    fr: {
      question: 'Qu\'est-ce qui a un visage et deux mains mais pas de bras ni de jambes?',
      options: ['Horloge', 'Montre', 'Lune', 'Soleil'],
      correct: 0,
      explanation: 'Une horloge a un cadran (visage) et des aiguilles (mains) mais pas de bras ni de jambes.'
    }
  },
  {
    id: 'riddle_005',
    difficulty: 'easy',
    en: {
      question: 'I have cities but no houses. I have mountains but no trees. What am I?',
      options: ['Map', 'Globe', 'Picture', 'Drawing'],
      correct: 0,
      explanation: 'A map shows cities and mountains but contains no actual houses or trees.'
    },
    zh: {
      question: '我有城市但没有房子，有山但没有树。我是什么？',
      options: ['地图', '地球仪', '图片', '画'],
      correct: 0,
      explanation: '地图显示城市和山，但没有真实的房子或树。'
    },
    fr: {
      question: 'J\'ai des villes mais pas de maisons. J\'ai des montagnes mais pas d\'arbres. Qu\'est-ce que je suis?',
      options: ['Carte', 'Globe', 'Photo', 'Dessin'],
      correct: 0,
      explanation: 'Une carte affiche des villes et des montagnes mais ne contient pas de vraies maisons ou d\'arbres.'
    }
  },
  {
    id: 'riddle_006',
    difficulty: 'easy',
    en: {
      question: 'What gets wet while drying?',
      options: ['Towel', 'Soap', 'Sponge', 'Cloth'],
      correct: 0,
      explanation: 'A towel gets wet while drying things (absorbing water).'
    },
    zh: {
      question: '什么东西在擦干的时候会变湿？',
      options: ['毛巾', '肥皂', '海绵', '布'],
      correct: 0,
      explanation: '毛巾在擦干东西时会变湿（吸收水分）。'
    },
    fr: {
      question: 'Qu\'est-ce qui devient mouillé en séchant?',
      options: ['Serviette', 'Savon', 'Éponge', 'Tissu'],
      correct: 0,
      explanation: 'Une serviette devient mouillée en séchant les choses (en absorbant l\'eau).'
    }
  },
  {
    id: 'riddle_007',
    difficulty: 'easy',
    en: {
      question: 'I am taken from a mine and shut up in a wooden case, yet I am very useful. What am I?',
      options: ['Pencil lead', 'Coal', 'Diamond', 'Gold'],
      correct: 0,
      explanation: 'Pencil lead is extracted from mines and put inside wooden pencil cases.'
    },
    zh: {
      question: '我来自矿山，被关在木制盒子里，但我很有用。我是什么？',
      options: ['铅芯', '煤', '钻石', '黄金'],
      correct: 0,
      explanation: '铅芯来自矿山，被放在木制铅笔盒里。'
    },
    fr: {
      question: 'Je suis extraite d\'une mine et enfermée dans une boîte en bois, mais je suis très utile. Qu\'est-ce que je suis?',
      options: ['Mine de crayon', 'Charbon', 'Diamant', 'Or'],
      correct: 0,
      explanation: 'La mine de crayon est extraite des mines et mise dans un étui en bois.'
    }
  },
  {
    id: 'riddle_008',
    difficulty: 'easy',
    en: {
      question: 'What is always coming but never arrives?',
      options: ['Tomorrow', 'Yesterday', 'Today', 'Evening'],
      correct: 0,
      explanation: 'Tomorrow is always coming but never truly arrives because when it does, it becomes today.'
    },
    zh: {
      question: '什么总是来但永远不会到达？',
      options: ['明天', '昨天', '今天', '晚上'],
      correct: 0,
      explanation: '明天总是来，但永远不会真正到达，因为当它到来时，它就变成了今天。'
    },
    fr: {
      question: 'Qu\'est-ce qui vient toujours mais n\'arrive jamais?',
      options: ['Demain', 'Hier', 'Aujourd\'hui', 'Soir'],
      correct: 0,
      explanation: 'Demain vient toujours mais n\'arrive jamais vraiment car quand il arrive, il devient aujourd\'hui.'
    }
  },

  // 中等难度 (16-25)
  {
    id: 'riddle_009',
    difficulty: 'medium',
    en: {
      question: 'What has a head and a tail but no body?',
      options: ['Coin', 'Snake', 'Key', 'Arrow'],
      correct: 0,
      explanation: 'A coin has a head (showing a face) and a tail (the reverse side) but no body.'
    },
    zh: {
      question: '什么东西有头有尾但没有身体？',
      options: ['硬币', '蛇', '钥匙', '箭'],
      correct: 0,
      explanation: '硬币有头面（显示一张脸）和尾面（反面），但没有身体。'
    },
    fr: {
      question: 'Qu\'est-ce qui a une tête et une queue mais pas de corps?',
      options: ['Pièce de monnaie', 'Serpent', 'Clé', 'Flèche'],
      correct: 0,
      explanation: 'Une pièce de monnaie a une tête (montrant un visage) et une queue (le revers) mais pas de corps.'
    }
  },
  {
    id: 'riddle_010',
    difficulty: 'medium',
    en: {
      question: 'The more you take, the more you leave behind. What am I?',
      options: ['Footsteps', 'Money', 'Time', 'Food'],
      correct: 0,
      explanation: 'The more footsteps you take, the more footprints you leave behind.'
    },
    zh: {
      question: '你拿得越多，留下的就越多。我是什么？',
      options: ['脚印', '金钱', '时间', '食物'],
      correct: 0,
      explanation: '你留下的脚印越多，你走过的脚印就越多。'
    },
    fr: {
      question: 'Plus tu en prends, plus tu en laisses derrière. Qu\'est-ce que je suis?',
      options: ['Empreintes de pas', 'Argent', 'Temps', 'Nourriture'],
      correct: 0,
      explanation: 'Plus vous faites de pas, plus d\'empreintes vous laissez derrière vous.'
    }
  },
  {
    id: 'riddle_011',
    difficulty: 'medium',
    en: {
      question: 'What can travel around the world while staying in a corner?',
      options: ['Stamp', 'Letter', 'Package', 'Postcard'],
      correct: 0,
      explanation: 'A stamp travels around the world (on letters) while staying in a corner of the envelope.'
    },
    zh: {
      question: '什么东西能环游世界，但只待在一个角落？',
      options: ['邮票', '信件', '包裹', '明信片'],
      correct: 0,
      explanation: '邮票能环游世界（在信件上），但只待在信封的一个角落。'
    },
    fr: {
      question: 'Qu\'est-ce qui peut voyager autour du monde en restant dans un coin?',
      options: ['Timbre', 'Lettre', 'Colis', 'Carte postale'],
      correct: 0,
      explanation: 'Un timbre voyage autour du monde (sur les lettres) en restant dans un coin de l\'enveloppe.'
    }
  },
  {
    id: 'riddle_012',
    difficulty: 'medium',
    en: {
      question: 'What is full of keys but cannot open any door?',
      options: ['Piano', 'Computer', 'Typewriter', 'Keyboard'],
      correct: 0,
      explanation: 'A piano has many keys but they are for playing music, not opening doors.'
    },
    zh: {
      question: '什么东西有很多钥匙，但不能开任何门？',
      options: ['钢琴', '电脑', '打字机', '键盘'],
      correct: 0,
      explanation: '钢琴有很多键，但它们是用来演奏音乐的，不是开门的。'
    },
    fr: {
      question: 'Qu\'est-ce qui est plein de clés mais ne peut ouvrir aucune porte?',
      options: ['Piano', 'Ordinateur', 'Machine à écrire', 'Clavier'],
      correct: 0,
      explanation: 'Un piano a de nombreuses touches pour jouer de la musique, pas pour ouvrir des portes.'
    }
  },
  {
    id: 'riddle_013',
    difficulty: 'medium',
    en: {
      question: 'What has a neck but no head?',
      options: ['Bottle', 'Giraffe', 'Scarf', 'Turtle'],
      correct: 0,
      explanation: 'A bottle has a neck (the narrow part) but no head.'
    },
    zh: {
      question: '什么有脖子但没有头？',
      options: ['瓶子', '长颈鹿', '围巾', '乌龟'],
      correct: 0,
      explanation: '瓶子有瓶颈（狭窄部分），但没有头。'
    },
    fr: {
      question: 'Qu\'est-ce qui a un cou mais pas de tête?',
      options: ['Bouteille', 'Girafe', 'Écharpe', 'Tortue'],
      correct: 0,
      explanation: 'Une bouteille a un goulot (la partie étroite) mais pas de tête.'
    }
  },
  {
    id: 'riddle_014',
    difficulty: 'medium',
    en: {
      question: 'I am a word that looks the same forwards and backwards. What am I?',
      options: ['Racecar', 'Beautiful', 'Happy', 'Simple'],
      correct: 0,
      explanation: 'Racecar is a palindrome - it reads the same forwards and backwards.'
    },
    zh: {
      question: '我是一个正读和倒读都一样的词。我是什么？',
      options: ['赛车（回文词）', '美丽', '快乐', '简单'],
      correct: 0,
      explanation: '"Racecar"是一个回文词——正读和倒读都是一样的。'
    },
    fr: {
      question: 'Je suis un mot qui se lit de la même manière à l\'endroit et à l\'envers. Qu\'est-ce que je suis?',
      options: ['Kayak', 'Beau', 'Heureux', 'Simple'],
      correct: 0,
      explanation: 'Kayak est un palindrome - il se lit de la même manière à l\'endroit et à l\'envers.'
    }
  },

  // 困难 (26+)
  {
    id: 'riddle_015',
    difficulty: 'hard',
    en: {
      question: 'What can run but has no legs, has a mouth but cannot eat, and has a bed but cannot sleep?',
      options: ['River', 'Fish', 'Stream', 'Ocean'],
      correct: 0,
      explanation: 'A river can run (flow), has a mouth (where it enters the sea), and has a bed (riverbed).'
    },
    zh: {
      question: '什么会跑但没有腿，有嘴但不能吃，有床但不能睡？',
      options: ['河流', '鱼', '小溪', '海洋'],
      correct: 0,
      explanation: '河流会流动（跑），有河口（流入海洋的地方），有河床。'
    },
    fr: {
      question: 'Qu\'est-ce qui peut courir mais n\'a pas de jambes, a une bouche mais ne peut pas manger, et a un lit mais ne peut pas dormir?',
      options: ['Rivière', 'Poisson', 'Ruisseau', 'Océan'],
      correct: 0,
      explanation: 'Une rivière peut couler, a une embouchure (où elle se jette dans la mer) et a un lit (lit de rivière).'
    }
  }
]

/**
 * 获取指定难度的问题
 */
export function getQuestionsByDifficulty(difficulty) {
  return riddleQuestions.filter(q => q.difficulty === difficulty)
}

/**
 * 获取随机问题
 */
export function getRandomQuestion() {
  return riddleQuestions[Math.floor(Math.random() * riddleQuestions.length)]
}

/**
 * 获取随机指定难度的问题
 */
export function getRandomQuestionByDifficulty(difficulty) {
  const questions = getQuestionsByDifficulty(difficulty)
  return questions[Math.floor(Math.random() * questions.length)]
}
